import { render } from "./SpecificationCard.vue?vue&type=template&id=0e93ee0a&scoped=true"
import script from "./SpecificationCard.vue?vue&type=script&lang=js"
export * from "./SpecificationCard.vue?vue&type=script&lang=js"

import "./SpecificationCard.vue?vue&type=style&index=0&id=0e93ee0a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0e93ee0a"

export default script